<div class="auth-page">
  <div class="auth-panel">
    <div class="auth-brand">
      <span class="mark">R</span>
      <h1>Rentwize</h1>
      <p>Enter the verification code emailed to<br /><strong>{{ email() }}</strong></p>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()" class="auth-form">
      <label>
        <span>OTP</span>
        <input
          type="text"
          formControlName="otp"
          inputmode="numeric"
          autocomplete="one-time-code"
          maxlength="8"
          placeholder="Enter code from email"
          spellcheck="false"
        />
      </label>

      @if (error()) {
        <div class="alert alert-error">{{ error() }}</div>
      }

      <button class="btn btn-primary btn-block" type="submit" [disabled]="loading()">
        {{ loading() ? 'Verifying…' : 'Verify & continue' }}
      </button>

      <a routerLink="/login" class="back-link">Back to login</a>
    </form>
  </div>
</div>
